import View from './view';
export const PollsTypeVoteResultScreen = View;
